import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {TranscriptItemObject} from '@PosterWhiteboard/items/transcript-item/transcript-item.types';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {SubtitleObject} from '@PosterWhiteboard/items/transcript-item/subtitle/subtitle.types';

export function useGetKeyFromSubtitlePropertiesForTranscriptItem<T extends keyof SubtitleObject>(key: T): SubtitleObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const itemObject = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];
    if (!itemObject) {
      return undefined;
    }

    if (itemObject.gitype !== ITEM_TYPE.TRANSCRIPT) {
      throw new Error(`Item isn't a transcript item`);
    }

    const transcriptItemObject = itemObject as TranscriptItemObject;
    const anySubtitleObject = Object.values(transcriptItemObject.subtitlesHashmap)[0];

    if (anySubtitleObject[key] !== undefined) {
      return anySubtitleObject[key];
    }

    return undefined;
  });
}
